module.exports = "https://web-assets.ifttt.com/packs/media/shared/favicon-coast-4287520f.png";